import { computed } from 'vue'
import { ChatStatus } from '../types/enums'

type ChatStatusSource = string | (() => string)

export function useMessageWindow(chatStatus: ChatStatusSource) {
  const resolvedChatStatus = computed(() =>
    typeof chatStatus === 'function' ? chatStatus() : chatStatus,
  )

  // La ventana de 24h de Meta y el estado "esperando respuesta de template"
  // los mantiene el backend (MetaSessionExpireJob → status EXPIRE;
  // envío/reactivación de template → status TEMPLATE) y los propaga por
  // WebSocket. El frontend solo debe reflejar chat.status, no recalcularlo
  // a partir de los timestamps de los mensajes.
  const isOutside24HourWindow = computed(() => resolvedChatStatus.value === ChatStatus.EXPIRE)

  const isAwaitingClientReply = computed(() => resolvedChatStatus.value === ChatStatus.TEMPLATE)

  return {
    isOutside24HourWindow,
    isAwaitingClientReply,
  }
}
